import { putRequestCase } from "@/stores/caseStore/backendApi";
import { useCaseStore } from "@/stores/caseStore/0_caseStore";
import { useSnackbarStore } from "@/stores/snackbarStore";
import { isEqual } from "lodash";

export async function clearMarker(parentKey: string, groupId: string, fieldKey: string, currentValue: any): Promise<void> {
  const store = useCaseStore();
  const snackbar = useSnackbarStore();

  if (!store.idPreview || !parentKey || !groupId || !fieldKey) {
    return;
  }

  const fieldEntry = store.previewValues[parentKey]?.[groupId]?.[fieldKey];
  if (!fieldEntry) {
    return;
  }

  if (fieldEntry?.marked === false || isEqual(currentValue, fieldEntry?.value)) {
    return;
  }

  fieldEntry.marked = false;

  try {
    await putRequestCase(`/protected/cases/save-preview/${store.idPreview}`, {
      values: store.previewValues,
    });
  } catch (error: unknown) {
    if (error instanceof Error) {
      snackbar.showSnackbar({
        message: error.message,
        type: "error",
      });
    }
  }
}
